"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableBody = exports.ExpandableHead = exports.ExpandableRow = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_collapsed_1 = (0, tslib_1.__importDefault)(require("react-collapsed"));
var box_1 = require("../box");
var expandable_body_1 = require("./components/expandable-body");
Object.defineProperty(exports, "ExpandableBody", { enumerable: true, get: function () { return expandable_body_1.ExpandableBody; } });
var expandable_head_1 = require("./components/expandable-head");
Object.defineProperty(exports, "ExpandableHead", { enumerable: true, get: function () { return expandable_head_1.ExpandableHead; } });
var animationStyles = {
    transitionDuration: '.2s',
};
function ExpandableRow(_a) {
    var children = _a.children, _b = _a.removeStyling, removeStyling = _b === void 0 ? false : _b, _c = _a.expanded, expanded = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, onToggleRow = _a.onToggleRow, _e = _a.shouldToggleOnClick, shouldToggleOnClick = _e === void 0 ? true : _e, _f = _a.borderRadius, borderRadius = _f === void 0 ? 3 : _f;
    var _g = (0, react_1.useState)(expanded), isExpanded = _g[0], setIsExpanded = _g[1];
    var _h = (0, react_collapsed_1.default)({
        isExpanded: isExpanded,
        expandStyles: animationStyles,
        collapseStyles: animationStyles,
    }), getCollapseProps = _h.getCollapseProps, getToggleProps = _h.getToggleProps;
    (0, react_1.useEffect)(function () {
        setIsExpanded(expanded);
    }, [expanded]);
    var headProps = {
        getToggleProps: getToggleProps({
            onClick: function () {
                if (!shouldToggleOnClick) {
                    onToggleRow === null || onToggleRow === void 0 ? void 0 : onToggleRow(isExpanded);
                    return;
                }
                setIsExpanded(function (oldExpanded) { return !oldExpanded; });
                onToggleRow === null || onToggleRow === void 0 ? void 0 : onToggleRow(!isExpanded);
            },
            disabled: disabled,
        }),
        isExpanded: isExpanded,
    };
    var bodyProps = {
        getCollapseProps: getCollapseProps,
    };
    if (removeStyling) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.cloneElement(children[0], headProps),
            react_1.default.cloneElement(children[1], bodyProps)));
    }
    return (react_1.default.createElement(box_1.Box, { border: 1, borderRadius: borderRadius, boxShadow: "card", style: { overflow: 'hidden' } },
        react_1.default.cloneElement(children[0], headProps),
        react_1.default.cloneElement(children[1], bodyProps)));
}
exports.ExpandableRow = ExpandableRow;
//# sourceMappingURL=index.js.map